import store from '@/state/store';
import { has } from 'lodash';

export const checkPermission = (module, key) => {
  const userData = store.getters['authUser/userData'];
  const permissions = userData?.role?.permissions || [];

  return has(permissions, module) && permissions[module].findIndex((i) => i == key) > -1;
};

const SHOW_ALL = 'list_view';
const SHOW_ONE = 'detailed_view';
const CREATE = 'create';
const UPDATE = 'update';
const DELETE = 'delete';
const APPROVE = 'approve';

export const roles = {
  module: 'roles',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const admins = {
  module: 'admins',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const tenants = {
  module: 'tenants',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const packages = {
  module: 'packages',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const promotions = {
  module: 'promotions',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const ads = {
  module: 'ads',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const brands = {
  module: 'brands',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const carModels = {
  module: 'car-models',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const carClasses = {
  module: 'car-classes',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const carOptions = {
  module: 'car-options',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const structures = {
  module: 'structure-categories',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const blogs = {
  module: 'blogs',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const contactUs = {
  module: 'contact-us',
  showAll: SHOW_ALL,
};
export const galleries = {
  module: 'galleries',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};

export const inspectionPackages = {
  module: 'inspection-packages',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const branches = {
  module: 'branches',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const vinReports = {
  module: 'vin-reports',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
  approve: APPROVE,
};

export const submissions = {
  module: 'submissions',
  showAll: SHOW_ALL,
  update: UPDATE,
};

export const faqCategories = {
  module: 'faq-categories',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const faqs = {
  module: 'faqs',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const countries = {
  module: 'countries',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const carBodyTypes = {
  module: 'car-body-types',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
  update: UPDATE,
  delete: DELETE,
};
export const packageSubscriptions = {
  module: 'package-subscriptions',
  showAll: SHOW_ALL,
  showOne: SHOW_ONE,
  create: CREATE,
};
export const subscriptions = {
  module: 'package-subscriptions',
  showAll: SHOW_ALL,
};
export const settings = {
  module: 'settings',
  showAll: SHOW_ALL,
  update: UPDATE,
};
export const financial = {
  module: 'financial',
  showAll: SHOW_ALL,
  update: UPDATE,
  approve: APPROVE,
};

export default {
  checkPermission,
  roles,
  admins,
  tenants,
  packages,
  promotions,
  ads,
  brands,
  carModels,
  carClasses,
  carOptions,
  structures,
  blogs,
  contactUs,
  galleries,
  inspectionPackages,
  branches,
  vinReports,
  submissions,
  faqCategories,
  faqs,
  countries,
  carBodyTypes,
  packageSubscriptions,
  subscriptions,
  settings,
  financial,
};
